



































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import NoImage from '@/components/NoImage.vue';
import { KnifeData, PhotoData } from './GalleryModels';
import { mdiFullscreen, mdiClose } from '@mdi/js';

@Component({
  components: {
    NoImage,
  },
})
export default class GalleryKnife extends Vue {

  private icons = { mdiFullscreen, mdiClose };

  @Prop() private knife!: KnifeData;

  private isGettingPhotos = false;
  /**
   * List of photos linked with the knife.
   */
  private photos: PhotoData[] = [];

  /**
   * Aspect ratio of photos.
   * Need it because without aspect ratio v-img inside v-carousel was not displayed correctly.
   */
  get photosAspectRatio(): number {
    return 1152 / 648;
  }

  mounted() {
    this.update();
  }

  @Watch('knife')
  private update() {
    this.photos = [];
    this.selectedPhotoIndex = 0;
    if (this.knife) {
      this.photos = this.knife.photos ?? [];
    }
  }

  /**
   * The selected photo index.
   */
  private selectedPhotoIndex = 0;
  
  /**
   * Getter on the selected photo depending on the index.
   */
  get selectedPhoto(): PhotoData|undefined {
    return this.photos[this.selectedPhotoIndex];
  }

  /**
   * Emit close event.
   */
  private emitClose() {
    this.$emit('close');
  }
}
